// removed by extract-text-webpack-plugin
module.exports = {"advancedFiltersTwin":"_1k2qyFofiO1hQw6D0BRly4","inputWrapper":"_2HBVFE_4RSTYPs0v5-HoQK","title":"_21QQmR2q3NKln54DA1fgt5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTwinInput/OMTwinInput.scss
// module id = 1681
// module chunks = 0